import Page from 'component/Page';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { selectCurrentUser } from 'redux/user/user.selector';
import sendRequest, {
    sendPost,
    // sendPut
} from 'util/request';
import Paths from 'util/paths';
import string from 'util/string';
import Urls from 'util/urls';
import Table from 'component/Table';
import Modal from 'component/Modal';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { formatDate, nNU, showConfirm, showToast, getParams } from 'util/utils';
import PocTrialAdd from './PocTrialAdd';

// export const accountRoleNameMap = {
//     0: string.ACCOUNT_ROLE_ADMIN,
//     1: string.ACCOUNT_ROLE_PARENT,
//     2: string.ACCOUNT_ROLE_CHILD,
// };

// export const accountStatusNameMap = {
//     true: string.ACTIVE,
//     false: string.INACTIVE,
// };

const GET_CHANNEL_INTERVAL = 0.25 * 1000;

const PocUserTrial = ({ data = { groupId: null } }) => {
	//-------------------------------HOOKS-------------------------------------------------------------
	const currentUser = useSelector(selectCurrentUser);
	const [ channelMember, setChannelMember ] = useState([]);
	const [ page, setPage ] = useState(1);
	const [ total, setTotal ] = useState(0);
	const [ pageSize, setPageSize ] = useState(10);
	const isAdmin = useMemo(
		() => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
		[ currentUser.accountRole ]
	);
	const isMonitorOnly = useMemo(
		() => currentUser.isMonitorOnly === 1,
		[ currentUser.isMonitorOnly ]
	);
	const [ selectedItem, setSelectedItem ] = useState([]);
	const [ searchId, setSearchId ] = useState('');
	const [ keyword, setKeyword ] = useState('');
	// const [ showLoading, setShowLoading ] = useState(false);
	const [ addTrial, setAddTrial ] = useState(null);
	const history = useHistory();
	const headers = isAdmin ?
	[
		string.POC_LOGIN_ID,
		string.POC_DISPLAY_NAME,
		string.POC_ID,
		// string.POC_ACCOUNT_SIP,
		string.POC_ACCOUNT_OWNER,
		string.POC_ACCOUNT_STATUS,
		string.POC_ACCOUNT_REGISTERED_DATE,
	] : [
		string.POC_LOGIN_ID,
		string.POC_DISPLAY_NAME,
		string.POC_ID,
		// string.POC_ACCOUNT_STATUS,
		string.POC_ACCOUNT_REGISTERED_DATE,
	];

	//------------------------------FUNCTIONS----------------------------------------------------------
	const doSearch = useCallback(
		async (page, pageSize, searchKeyword) => {
			let data = await sendPost({
				url: isAdmin ? Urls.pocaccount.list : Urls.pocaccount.userlist,
				body: {
					id: currentUser.id,
					offset: (page - 1) * pageSize,
					size: pageSize,
					keyword: searchKeyword,
					status: false,
				},
			});
			const { total, result } = data;
			console.log(result);
			setChannelMember(result);
			setTotal(total);
			return result;
		},
		[]
	);
	useEffect(() => {
		doSearch(page, pageSize, keyword);
	}, [ page, pageSize, keyword, doSearch ]);
	useEffect(() => {
		let delay = setInterval(() => {
			setKeyword(searchId.trim());
		}, GET_CHANNEL_INTERVAL);
		return () => {
			clearInterval(delay);
		};
	}, [ searchId ]);
	const dataTable = useCallback(
		// (data) => data.filter((raw) => raw?.status === 0).map((raw, key) =>
		(data) => data.map((raw, key) =>
			({
				key: raw?.id,
				data: isAdmin ?
					[
						raw?.username,
						raw?.displayName,
						raw?.pocId.toString().padStart(6, '0'),
						nNU(raw?.email) && raw?.email.length > 0 ? raw?.email : currentUser.email,
						raw?.status === 1 ? '有効' : '無効',
						formatDate(raw?.registerDate, 'YYYY/MM/DD'),
					] : [
						raw.username,
						raw?.displayName,
						raw?.pocId.toString().padStart(6, '0'),
						// raw?.status === 1 ? '有効' : '無効',
						formatDate(raw?.registerDate, 'YYYY/MM/DD'),
					],
				raw,
			})),
			[]
	);
	const onSelect = (e) => {
		const { raw } = e;
		if (selectedItem.some(item => item.pocId === raw.pocId)) {
			setSelectedItem([]);
		} else {
			setSelectedItem([raw]);
		}
	};

	const actions = (isMonitorOnly === false) ?
		[
			({ raw }) => {
				if (raw.status !== 0) {
						return;
				}
				let idx = -1;
				selectedItem?.forEach((item, index) => {
						if (item.pocId === raw.pocId) {
								idx = index;
								return;
						}
				});
				return selectedItem.indexOf(raw.pocId) > -1 ? null :
					{
						render: idx > -1 ? 'trialselected' : 'trialselect',
						onClick: onSelect,
					};
			},
		] : [];
	const onAddTrial = () => {
		if (selectedItem.length < 1) {
			return;
		}
		const pocId = selectedItem[ 0 ].pocId;
		const data = {
			pocId: pocId,
		};
		// if (isAdmin) {
		//     data = {
		//         ...data,
		//         remainingTime: ''
		//     };
		// }
		showConfirm({
			body: string.POC_ACCOUNT_TRIAL_ADD_CONFIRM,
			defaultAction: () => {
				sendPost({
						url: Urls.pocaccount.trial,
						body: data,
				}).then((res) => {
					showToast(string.POC_ACCOUNT_TRIAL_SUCCESS, 'success');
					currentUser.pocTrial = 0;
					history.push(Paths.pocaccount.list);
				}).catch((e) => {
					console.log('削除エラー');
				});
			},
		});
	};
	const mainActions = total > 0 ?
		isAdmin ?
			[
				{
					icon: 'approve',
					title: string.POC_ACCOUNT_TRIAL_ACTIVE,
					onClick: () => {
						if(selectedItem.length > 0){
							let item = selectedItem[0];
							setAddTrial(item);
						} else {
							setAddTrial(null);
						}
					},
				},
			] : [
				{
					icon: 'approve',
					title: string.POC_ACCOUNT_TRIAL_ACTIVE,
					onClick: () => onAddTrial(),
				},
			] : null;

	//-------------------------------RETURN------------------------------------------------------------
	return (
		<>
			<Page
				title={string.POC_ACCOUNT_TRIAL}
				body={
					<>
						<Table
							className="nowrap"
							mainActions={mainActions}
							page={page}
							pageSize={pageSize}
							total={total}
							onPageChanged={setPage}
							onPageSizeChanged={setPageSize}
							headers={headers}
							data={dataTable(channelMember)}
							isPaging={true}
							actions={actions}
							selectedCount={selectedItem.length}
							search={true}
							onSearch={(value) => setSearchId(value)}
							placeHolder={ isAdmin ?
								`${string.POC_LOGIN_ID}、 ${string.POC_DISPLAY_NAME}` : `${string.POC_DISPLAY_NAME}`
							}
						/>
					</>
				}
			/>
      <Modal
        show={!!addTrial}
        onHide={() => setAddTrial(null)}
        body={
          <>
            {!!addTrial && (
              <PocTrialAdd
                onUpdated={() => {
                  setAddTrial(null);
                  doSearch(page, pageSize);
                }}
                data={addTrial}
              />
            )}
          </>
        }
      />

		</>
	);
};

export default PocUserTrial;
